import React from "react";
import { createRoot } from "react-dom/client";
import Swal from 'sweetalert2';
import CookieConsent from "@root/CookieConsent";

window.Swal = Swal;

const roots = {};

const renderComponent = (Component, rootId, props = {}) => {
  const rootElement = document.getElementById(rootId);
  if (rootElement) {
    if (!roots[rootId]) {
      roots[rootId] = createRoot(rootElement);
    }
    roots[rootId].render(<Component {...props} />);
  }
};

renderComponent(CookieConsent, "CookieConsent");
